import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, NgForm, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DescriptionModel } from '@core/services/base.model';
import { ClientService } from '@core/services/client/client.service';
import { IpFiltering, IpFilteringEditErrorMessage } from '@core/services/ip-filtering/ip-filtering.model';
import { IpFilteringService } from '@core/services/ip-filtering/ip-filtering.service';

@Component({
  selector: 'Teranet-IpFilteringEdit',
  templateUrl: './ip-filtering-edit.component.html'
})
export class IpFilteringEditComponent implements OnInit {
  clientInfos: DescriptionModel[] = [];
  id: number;
  ipFilteringForm: FormGroup;
  ipFilteringEditErrorMessage = IpFilteringEditErrorMessage;
  isEdit: boolean = false;
  title: string;

  static readonly defaultTitle = 'IP Filter';

  constructor(
    private ipFilteringService: IpFilteringService,
    private clientService: ClientService,
    public dialogRef: MatDialogRef<IpFilteringEditComponent>,

    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.ipFilteringForm = new FormGroup(
      {
        id: new FormControl(0),
        clientInfoId: new FormControl('', Validators.required),
        ipFilterName: new FormControl('', Validators.maxLength(50)),
        ipFilterStart: new FormControl('', [
          Validators.required,
          Validators.pattern(
            '^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$'
          ),
        ]),
        ipFilterEnd: new FormControl('', [
          Validators.required,
          Validators.pattern(
            '^((25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?).){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$'
          ),
        ]),
        isActive: new FormControl(true),
      },
      { validators: this.ipAddressRangeValidator() }
    );
  }

  ngOnInit(): void {
    if (this.data.row != null) {
      if ('clientInfoId' in this.data.row) {
        this.title = 'Edit ' + IpFilteringEditComponent.defaultTitle;
        const getClientInfos = this.clientService.getClientInfoDescriptions();
        getClientInfos.subscribe(data => {
          this.clientInfos = data as DescriptionModel[];
          this.id = this.data.row.id;
          this.ipFilteringForm.patchValue({ ...this.data.row });
        });

        this.isEdit = true;
      } else if (this.data.row.constructor.name === 'Array') {
        this.title = 'Add ' + IpFilteringEditComponent.defaultTitle;
        this.clientInfos = this.data.row as DescriptionModel[];
        this.id = -1;
        this.isEdit = false;
      }
    }
  }

  createOrUpdateIpFiltering(form: NgForm) {
    if (this.ipFilteringForm.valid) {
      const ipFilteringData: IpFiltering = {
        id: this.id,
        clientInfoId: this.ipFilteringForm.get('clientInfoId').value,
        ipFilterName: this.ipFilteringForm.get('ipFilterName').value,
        ipFilterStart: this.ipFilteringForm.get('ipFilterStart').value,
        ipFilterEnd: this.ipFilteringForm.get('ipFilterEnd').value,
        isActive: this.ipFilteringForm.get('isActive').value ? true : false,
        isDeleted: false,
      };
      let isCreateOrUpdateOrDelete = this.isEdit ? 1 : -1;
      const createOrUpdateOrDeleteIpFiltering = this.ipFilteringService.createOrUpdateOrDeleteIpFiltering(
        ipFilteringData,
        isCreateOrUpdateOrDelete
      );
      createOrUpdateOrDeleteIpFiltering.subscribe(data => {
        let test = data;
      });

      this.dialogRef.close(ipFilteringData);
      form.resetForm();
    }
  }

  ipAddressRangeValidator() {
    return (form: FormGroup) => {
      const ipFilterStart = form.get('ipFilterStart');
      const ipFilterEnd = form.get('ipFilterEnd');
      const miniVal =
        (ipFilterEnd.errors == null ||
          (ipFilterEnd.errors != null &&
            ipFilterEnd.errors.pattern == undefined &&
            ipFilterEnd.errors.required == undefined)) &&
          this.iPtoNum(ipFilterStart.value) >= this.iPtoNum(ipFilterEnd.value)
          ? { min: ipFilterStart.value }
          : null;
      const ipFilterStartExistedErrors =
        ipFilterStart.errors != null &&
          (ipFilterStart.errors.pattern != undefined || ipFilterStart.errors.required != undefined)
          ? ipFilterStart.errors
          : null;
      if (miniVal || ipFilterStartExistedErrors) {
        form.get('ipFilterStart').setErrors({ ...ipFilterStartExistedErrors, ...miniVal });
      } else {
        form.get('ipFilterStart').setErrors(null);
      }
      const ipFilterEndExistedErrors =
        ipFilterEnd.errors != null &&
          (ipFilterEnd.errors.pattern != undefined || ipFilterEnd.errors.required != undefined)
          ? ipFilterEnd.errors
          : null;
      if (miniVal || ipFilterEndExistedErrors) {
        form.get('ipFilterEnd').setErrors({ ...ipFilterEndExistedErrors, ...miniVal });
      } else {
        form.get('ipFilterEnd').setErrors(null);
      }

      return miniVal;
    };
  }

  iPtoNum(ip) {
    return Number(
      ip
        .split('.')
        .map(d => ('000' + d).substr(-3))
        .join('')
    );
  }

  onClose(): void {
    this.dialogRef.close(this.ipFilteringForm.value);
  }
}
